module.exports = __webpack_public_path__ + "img/vinho.7cb51286.svg";